import { Link } from "gatsby"
import React, { useEffect, useState } from "react"
import useRoutePath from "../../../hooks/useRoutePath"
import useWebsite from "../../../hooks/useWebsite"
import logo from "../../../images/Harvia_sauna_spa-logo.svg"
import DatoMainNav from "../../dato/DatoMainNav"
import * as styles from "./PageHeader.module.scss"
import TopNav from "./TopNav"

type PageHeaderProps = { mainMenu?: Queries.DatoMainNavTreeFragment | null }

const PageHeader = (props: PageHeaderProps) => {
  //console.log('Rendering PageHeader', props)

  const [atTop, setAtTop] = useState<boolean>(true)

  const getRoutePath = useRoutePath()
  const frontPageUrl = getRoutePath(useWebsite().rootRoute?.originalId)

  useEffect(() => {
    function onScroll(_: Event) {
      const scrollTop = !(document.body.scrollTop || document.documentElement.scrollTop)
      if (scrollTop !== atTop) setAtTop(scrollTop)
    }

    document.addEventListener("scroll", onScroll)
    return () => {
      document.removeEventListener("scroll", onScroll)
    }
  })

  return (
    <header className={styles.container}>
      <div className={`${styles.content} layout-container`}>
        {frontPageUrl ? (
          <Link to={frontPageUrl} className={styles.logo + " " + styles[atTop ? "atTop" : ""]}>
            <img src={logo} alt="Harvia Logo" />
          </Link>
        ) : (
          <div className={styles.logo + " " + styles[atTop ? "atTop" : ""]}>
            <img src={logo} alt="Harvia Logo" />
          </div>
        )}
        <div className={styles.nav}>
          <TopNav />
          {props.mainMenu && <DatoMainNav nodes={props.mainMenu.nodes} />}
        </div>
      </div>
    </header>
  )
}

export default PageHeader
